import he from 'he'

const sortByPortAndDay = (portOrder) => {
	const sortCompare = (a, b) => {
		// sort by port, by day in port, then alphabetically
		let aPort = portOrder.indexOf(a.Code.substring(0, 3))
		let aDay = a.StartDateTime
		let bPort = portOrder.indexOf(b.Code.substring(0, 3))
		let bDay = b.StartDateTime
		if (aPort === -1) aPort = portOrder.length
		if (bPort === -1) bPort = portOrder.length
		if (aPort < bPort) return -1
		if (aPort > bPort) return 1
		if (aDay < bDay) return -1
		if (aDay > bDay) return 1
		if (he.decode(a.Title).toLowerCase() < he.decode(b.Title).toLowerCase())
			return -1
		if (he.decode(a.Title).toLowerCase() > he.decode(b.Title).toLowerCase())
			return 1
		if (a.Code > b.Code) return 1
		if (a.Code < b.Code) return -1
		return 0
	}
	return sortCompare
}

export default sortByPortAndDay



// WEBPACK FOOTER //
// ./portal-components/sortByPortAndDay/index.js